import {ActionType, createAction, props} from '@ngrx/store';
import {
  ActivationCodeReq,
  ContinueAsGuest,
  Customer,
  LoginReq,
  LoginRes,
  LoginSocialReq,
  RegisterReq,
  RegisterRes,
  VerifyActivationCodeReq,
} from '../../models';

// Login
export const LOGIN = '@Login/signin';
export const LOGIN_SIGNIN_ERROR = '@Login/signin/error';
export const LOGIN_SIGNIN_SUCCESS = '@Login/signin/success';
export const LOGIN_SOCIAL = '@Login/signin/social';
export const REFRESH_SUCCESS = '@Login/refresh/success';

// Guest
export const LOGIN_GUEST = '@Login/guest';
export const LOGIN_GUEST_BACK = '@Login/guest/back';
// Register
export const REGISTER = '@Login/register';
export const REGISTER_SUCCESS = '@Login/register/success';
export const REGISTER_ERROR = '@Login/register/error';

// Activation Code -Verify
export const LOGIN_VERIFY_CODE = '@Login/verifyCode';
export const LOGIN_VERIFY_CODE_SUCCESS = '@Login/verifyCode/success';
export const LOGIN_VERIFY_CODE_FAIL = '@Login/verifyCode/fail';

// Activation Code - Resend
export const LOGIN_RESEND_CODE = '@Login/verifyCode/resend';
export const LOGIN_RESEND_CODE_SUCCESS = '@Login/verifyCode/resend/success';
export const LOGIN_RESEND_CODE_FAIL = '@Login/verifyCode/resend/fail';

// Forget password
export const FORGET_PASSWORD = '@Login/forgetPassword';
export const FORGET_PASSWORD_SUCCESS = '@Login/forgetPassword/success';
export const FORGET_PASSWORD_FAIL = '@Login/forgetPassword/fail';

// Remove the account
export const REMOVE_ACCOUNT = '@Login/remove';
// Store profile data
export const PROFILE = '@Login/profile';

// Login
export const login = createAction(
  LOGIN,
  props<{
    payload: LoginReq;
  }>()
);
export const loginError = createAction(
  LOGIN_SIGNIN_ERROR,
  props<{
    payload: LoginRes;
  }>()
);

export const loginSuccess = createAction(
  LOGIN_SIGNIN_SUCCESS,
  props<{
    payload: LoginRes;
  }>()
);
export const loginSocial = createAction(
  LOGIN_SOCIAL,
  props<{
    payload: LoginSocialReq;
  }>()
);

// Guest
export const loginGuest = createAction(
  LOGIN_GUEST,
  props<{
    payload: ContinueAsGuest;
  }>()
);
export const backToGuest = createAction(
  LOGIN_GUEST_BACK,
  props<{
    payload: { redirectToLogin: boolean };
  }>()
);

// Register
export const register = createAction(
  REGISTER,
  props<{
    payload: RegisterReq;
  }>()
);

export const registerError = createAction(
  REGISTER_ERROR,
  props<{
    payload?: RegisterRes;
  }>()
);

export const registerSuccess = createAction(
  REGISTER_SUCCESS,
  props<{
    payload: RegisterRes;
  }>()
);
// Activation Code -Verify
export const verificationCode = createAction(
  LOGIN_VERIFY_CODE,
  props<{
    payload: VerifyActivationCodeReq;
  }>()
);
export const verificationCodeSuccess = createAction(
  LOGIN_VERIFY_CODE_SUCCESS,
  props<{
    payload: LoginRes;
  }>()
);
export const verificationCodeFail = createAction(
  LOGIN_VERIFY_CODE_FAIL,
  props<{
    payload: LoginRes;
  }>()
);

// Activation Code - Resend
export const resendActivationCode = createAction(
  LOGIN_RESEND_CODE,
  props<{
    payload: ActivationCodeReq;
  }>()
);
export const resendActivationCodeSuccess = createAction(
  LOGIN_RESEND_CODE_SUCCESS,
  props<{
    payload: RegisterRes;
  }>()
);
export const resendActivationCodeFail = createAction(
  LOGIN_RESEND_CODE_FAIL,
  props<{
    payload: RegisterRes;
  }>()
);

// Forget Password
export const forgetPassword = createAction(
  FORGET_PASSWORD,
  props<{
    payload: { key: string; useEmail: boolean; mobileCode?: string };
  }>()
);
export const forgetPasswordSuccess = createAction(
  FORGET_PASSWORD_SUCCESS,
  props<{
    payload: RegisterRes;
  }>()
);
export const forgetPasswordFail = createAction(
  FORGET_PASSWORD,
  props<{
    payload: RegisterRes;
  }>()
);

// Remove the account
export const removeAccount = createAction(
  REMOVE_ACCOUNT,
  props<{
    payload: undefined;
  }>()
);
// load profile
export const StoreProfile = createAction(
  PROFILE,
  props<{
    payload: Customer;
  }>()
);
export const refreshSuccess = createAction(
  REFRESH_SUCCESS,
  props<{
    payload: LoginRes;
  }>()
);

export type LoginActions =
  | ActionType<typeof login>
  | ActionType<typeof loginError>
  | ActionType<typeof loginError>
  | ActionType<typeof loginSocial>
  | ActionType<typeof loginGuest>
  | ActionType<typeof backToGuest>
  | ActionType<typeof register>
  | ActionType<typeof registerSuccess>
  | ActionType<typeof registerError>
  | ActionType<typeof verificationCode>
  | ActionType<typeof verificationCodeSuccess>
  | ActionType<typeof verificationCodeFail>
  | ActionType<typeof resendActivationCode>
  | ActionType<typeof resendActivationCodeSuccess>
  | ActionType<typeof resendActivationCodeFail>
  | ActionType<typeof forgetPassword>
  | ActionType<typeof removeAccount>;
